import { Component, Event, EventEmitter, Method, Prop, Watch, h } from '@stencil/core';
import { LocaleService } from './locale-service';

@Component({
	tag: 'zds-config',
	shadow: true,
})
export class ZdsConfig {
	@Prop() locale: string;

	@Event({ bubbles: true }) zdsLocaleChange: EventEmitter;

	componentDidLoad() {
		if (this.locale && LocaleService.locale !== this.locale) {
			this.setLocale(this.locale);
		}
	}

	@Watch('locale')
	handleLocaleChange(newValue: string, oldValue: string) {
		if (newValue !== oldValue) {
			this.setLocale(newValue);
		}
	}

	setLocale(locale: string) {
		LocaleService.locale = locale;
		this.zdsLocaleChange.emit(locale);
	}

	@Method()
	async setTranslationOverrides(overrides: object) {
		LocaleService.setTranslationOverrides(overrides);
		this.zdsLocaleChange.emit(LocaleService.locale);
	}

	@Method()
	async resetTranslationOverrides() {
		LocaleService.setTranslationOverrides({});
		this.zdsLocaleChange.emit(LocaleService.locale);
	}

	@Method()
	async getInstance(): Promise<LocaleService> {
		return LocaleService;
	}

	render() {
		return <slot />;
	}
}
